import React from "react";
import "./Front.css";

export default class Front extends React.Component {
  render() {
    return (
      <div className="front-container">
        <div className="front-text-container">
          <div className="front-main-text">
            MILTON LI
          </div>

          <div className="front-desc-text">
            Entrepreneur, Developer, and Designer.
          </div>
        </div>
      </div>
    );
  }
}
